import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { OrderClient } from "./OrderClient"
import { OrderClientPaid } from "./OrderClientPaid"
import * as TrinityAPI from "@/requests/TrinityAPI"

type Params = {
  id?: string
}

export const OrderClientCommon = () => {
  const { id } = useParams<Params>()

  const [orderStatus, setOrderStatus] = useState<string | null>(null)

  useEffect(() => {
    if (id && id !== "new") {
      TrinityAPI.getOrder(Number(id), response => {
        if (response.status === 200) {
          setOrderStatus(response.data.status)
        }
      })
    }
  }, [id])

  if (id !== "new" && id && !orderStatus) {
    return null
  }

  if (id === "new" || orderStatus === "NEW") {
    return <OrderClient />
  } else {
    return <OrderClientPaid />
  }
}
